// Industry-specific quote examples for homepage
export const industryQuotes = [
  {
    id: 'painter',
    name: 'House Painting',
    icon: '🎨',
    description: 'Premium interior and exterior painting',
    tiers: {
      good: {
        title: 'Basic Paint Job',
        price: 2500,
        description: 'Quality exterior paint with 1 coat primer',
        bulletPoints: ['Pressure washing', 'Basic prep work', '1 coat primer + 1 coat paint', 'Standard color selection']
      },
      better: {
        title: 'Premium Paint Package', 
        price: 3500,
        description: 'Premium paint with enhanced durability',
        bulletPoints: ['Pressure washing', 'Comprehensive prep work', '1 coat primer + 2 coats premium paint', 'Extended color selection', 'Trim detail work']
      },
      best: {
        title: 'Luxury Complete Package',
        price: 4500,
        description: 'Top-tier paint with full exterior enhancement',
        bulletPoints: ['Pressure washing', 'Complete surface prep & repair', '2 coats primer + 2 coats luxury paint', 'Custom color matching', 'Trim & detail work', 'Protective sealant coating', '5-year warranty']
      }
    }
  },
  {
    id: 'hvac',
    name: 'HVAC Services',
    icon: '🌡️',
    description: 'Efficient heating and cooling installations',
    tiers: {
      good: {
        title: 'Standard System',
        price: 4500,
        description: 'Reliable HVAC system installation',
        bulletPoints: ['Basic 14 SEER unit', 'Standard installation', 'Basic thermostat', '1-year parts warranty']
      },
      better: {
        title: 'Energy Efficient System',
        price: 6500,
        description: 'High-efficiency system with smart features',
        bulletPoints: ['16 SEER high-efficiency unit', 'Professional installation', 'Programmable smart thermostat', 'Enhanced air filtration', '3-year extended warranty']
      },
      best: {
        title: 'Premium Smart System',
        price: 8500,
        description: 'Top-tier smart HVAC with zone control',
        bulletPoints: ['18+ SEER premium unit', 'Complete system upgrade', 'Advanced smart thermostat with app control', 'Multi-zone climate control', 'Premium air purification system', '5-year comprehensive warranty', 'Annual maintenance plan']
      }
    }
  },
  {
    id: 'pest-control',
    name: 'Pest Control',
    icon: '🐛',
    description: 'Comprehensive prevention and targeted treatments',
    tiers: {
      good: {
        title: 'Basic Treatment',
        price: 150,
        description: 'Essential pest control service',
        bulletPoints: ['Interior & exterior spray', 'Common pest treatment', 'Quarterly service', 'Basic guarantee']
      },
      better: {
        title: 'Complete Protection',
        price: 220,
        description: 'Comprehensive pest prevention program',
        bulletPoints: ['Interior & exterior treatment', 'Specialized pest targeting', 'Bi-monthly service', 'Rodent monitoring', '6-month guarantee', 'Emergency callbacks']
      },
      best: {
        title: 'Premium Shield Program',
        price: 320,
        description: 'Ultimate pest prevention with ongoing monitoring',
        bulletPoints: ['Complete property assessment', 'Customized treatment plan', 'Monthly monitoring visits', 'Rodent exclusion services', 'Termite inspection included', '12-month guarantee', 'Unlimited emergency service', 'Seasonal adjustment treatments']
      }
    }
  },
  {
    id: 'web-design',
    name: 'Web Design',
    icon: '💻',
    description: 'Modern websites with measurable results',
    tiers: {
      good: {
        title: 'Starter Website',
        price: 2500,
        description: 'Professional 5-page business website',
        bulletPoints: ['5-page custom design', 'Mobile responsive', 'Contact form', 'Basic SEO setup', '3 months support']
      },
      better: {
        title: 'Business Pro Website',
        price: 4500,
        description: 'Advanced website with enhanced features',
        bulletPoints: ['10-page custom design', 'Mobile & tablet optimized', 'Contact forms & lead capture', 'Advanced SEO optimization', 'Social media integration', 'Analytics setup', '6 months support & updates']
      },
      best: {
        title: 'Enterprise Website Solution',
        price: 7500,
        description: 'Complete digital presence with e-commerce',
        bulletPoints: ['Unlimited pages', 'Custom e-commerce functionality', 'Advanced lead generation', 'Comprehensive SEO strategy', 'Social media automation', 'Performance optimization', 'Security features', '12 months support & maintenance', 'Monthly performance reports']
      }
    }
  },
  {
    id: 'wedding-photography',
    name: 'Wedding Photography',
    icon: '📸',
    description: 'Timeless coverage with editorial artistry',
    tiers: {
      good: {
        title: 'Essential Package',
        price: 1800,
        description: '6-hour wedding coverage',
        bulletPoints: ['6 hours of coverage', '200+ edited photos', 'Online gallery', 'Basic photo editing', 'Digital delivery']
      },
      better: {
        title: 'Complete Wedding Package',
        price: 2800,
        description: '8-hour coverage with enhanced services',
        bulletPoints: ['8 hours of coverage', '400+ edited photos', 'Engagement session included', 'Premium photo editing', 'Online gallery with download', 'Print release', 'USB drive with all photos']
      },
      best: {
        title: 'Luxury Wedding Experience',
        price: 4200,
        description: 'Full-day coverage with premium services',
        bulletPoints: ['10+ hours of coverage', '600+ edited photos', 'Engagement & bridal session', 'Professional photo editing & retouching', 'Custom wedding album', 'Online gallery with download', 'Print release & rights', 'Second photographer', 'Same-day preview photos', 'Complimentary anniversary session']
      }
    }
  },
  {
    id: 'landscaping',
    name: 'Landscaping',
    icon: '🌿',
    description: 'Custom landscapes with lasting appeal',
    tiers: {
      good: {
        title: 'Basic Landscape Refresh',
        price: 3500,
        description: 'Essential landscaping improvements',
        bulletPoints: ['Lawn renovation', 'Basic plant installation', 'Mulching', 'Basic irrigation repair', '30-day plant guarantee']
      },
      better: {
        title: 'Complete Landscape Makeover',
        price: 6500,
        description: 'Comprehensive landscape transformation',
        bulletPoints: ['Custom landscape design', 'Premium plant selection', 'Irrigation system upgrade', 'Decorative stone & mulching', 'Seasonal color planning', '90-day plant guarantee', 'Spring maintenance visit']
      },
      best: {
        title: 'Luxury Landscape Design',
        price: 12000,
        description: 'Premium landscape with hardscaping features',
        bulletPoints: ['Professional landscape architecture', 'Premium plant & tree installation', 'Custom hardscaping (patios, walkways)', 'Advanced irrigation with smart controls', 'Outdoor lighting installation', 'Seasonal maintenance program', '1-year comprehensive guarantee', 'Quarterly design consultations']
      }
    }
  },
  {
    id: 'roofing',
    name: 'Roofing Services',
    icon: '🏠',
    description: 'Durable roof replacements and repairs',
    tiers: {
      good: {
        title: 'Basic Roof Repair',
        price: 8500,
        description: 'Essential roofing repair and maintenance',
        bulletPoints: ['Standard asphalt shingles', 'Basic installation', 'Debris cleanup', '5-year materials warranty']
      },
      better: {
        title: 'Premium Roof Replacement',
        price: 15000,
        description: 'Complete roof replacement with upgraded materials',
        bulletPoints: ['Architectural shingles', 'Complete tear-off and replacement', 'Enhanced underlayment', 'Gutter inspection & repair', '10-year materials & labor warranty', 'Storm damage protection']
      },
      best: {
        title: 'Luxury Complete Roofing System',
        price: 25000,
        description: 'Premium roofing with comprehensive upgrades',
        bulletPoints: ['Premium impact-resistant shingles', 'Complete system upgrade with ventilation', 'Ice & water barrier protection', 'New gutters & downspouts', 'Attic insulation upgrade', '15-year comprehensive warranty', 'Annual inspection program', 'Emergency repair priority']
      }
    }
  },
  {
    id: 'plumbing',
    name: 'Plumbing Services',
    icon: '🚿',
    description: 'Expert plumbing installations and repairs',
    tiers: {
      good: {
        title: 'Standard Plumbing Service',
        price: 450,
        description: 'Basic plumbing repair and maintenance',
        bulletPoints: ['Pipe repair/replacement', 'Fixture installation', 'Basic leak detection', '30-day service guarantee']
      },
      better: {
        title: 'Complete Plumbing Solution',
        price: 1200,
        description: 'Comprehensive plumbing system service',
        bulletPoints: ['Advanced pipe diagnostics', 'Premium fixture installation', 'Water heater service', 'Drain cleaning & inspection', '90-day warranty', 'Priority scheduling for future needs']
      },
      best: {
        title: 'Premium Plumbing System Upgrade',
        price: 3500,
        description: 'Full plumbing system modernization',
        bulletPoints: ['Complete repiping with premium materials', 'Smart water monitoring system', 'High-efficiency water heater upgrade', 'Whole-house water filtration', 'Emergency shutoff system', '2-year comprehensive warranty', 'Annual maintenance plan']
      }
    }
  },
  {
    id: 'electrical',
    name: 'Electrical Services',
    icon: '⚡',
    description: 'Professional electrical installations and upgrades',
    tiers: {
      good: {
        title: 'Basic Electrical Service',
        price: 350,
        description: 'Standard electrical repairs and installations',
        bulletPoints: ['Outlet/switch installation', 'Basic wiring repair', 'Circuit breaker service', 'Safety inspection']
      },
      better: {
        title: 'Electrical System Upgrade',
        price: 1500,
        description: 'Enhanced electrical system improvements',
        bulletPoints: ['Panel upgrade to modern standards', 'GFCI outlet installation', 'Surge protection system', 'LED lighting conversion', '1-year warranty on all work']
      },
      best: {
        title: 'Smart Home Electrical Package',
        price: 4500,
        description: 'Complete electrical modernization with smart features',
        bulletPoints: ['Complete electrical panel replacement', 'Whole-house surge protection', 'Smart switch & outlet installation', 'EV charging station prep', 'Home automation wiring', 'Energy monitoring system', '3-year comprehensive warranty']
      }
    }
  },
  {
    id: 'solar',
    name: 'Solar Installation',
    icon: '☀️',
    description: 'Sustainable solar energy systems',
    tiers: {
      good: {
        title: 'Basic Solar Package',
        price: 12000,
        description: '5kW residential solar system',
        bulletPoints: ['20 standard solar panels', 'Basic inverter system', 'Standard mounting', 'Grid-tie installation', '10-year equipment warranty']
      },
      better: {
        title: 'Premium Solar System',
        price: 18000,
        description: '8kW high-efficiency solar installation',
        bulletPoints: ['32 high-efficiency panels', 'Premium inverter with monitoring', 'Optimized panel placement', 'Enhanced mounting system', '15-year equipment warranty', 'Production monitoring app']
      },
      best: {
        title: 'Complete Energy Independence',
        price: 28000,
        description: '12kW solar with battery backup',
        bulletPoints: ['48 premium solar panels', 'Battery storage system', 'Smart energy management', 'EV charging integration', 'Backup power capability', '20-year comprehensive warranty', 'Annual system maintenance', 'Energy usage optimization']
      }
    }
  },
  {
    id: 'pool-construction',
    name: 'Pool Construction',
    icon: '🏊‍♂️',
    description: 'Custom pools with lasting craftsmanship',
    tiers: {
      good: {
        title: 'Basic Pool Package',
        price: 35000,
        description: 'Standard in-ground pool installation',
        bulletPoints: ['16x32 fiberglass pool', 'Basic filtration system', 'Standard deck finish', 'Basic lighting', '1-year warranty']
      },
      better: {
        title: 'Premium Pool Design',
        price: 55000,
        description: 'Custom pool with enhanced features',
        bulletPoints: ['Custom-shaped concrete pool', 'Saltwater system', 'Premium tile & coping', 'LED lighting package', 'Automatic pool cover', '3-year structural warranty']
      },
      best: {
        title: 'Luxury Resort-Style Pool',
        price: 85000,
        description: 'Complete backyard aquatic paradise',
        bulletPoints: ['Custom infinity edge design', 'Integrated spa & water features', 'Smart automation system', 'Premium landscaping integration', 'Outdoor kitchen prep', 'Pool house foundation', '5-year comprehensive warranty', 'Monthly maintenance service']
      }
    }
  },
  {
    id: 'interior-design',
    name: 'Interior Design',
    icon: '🛋️',
    description: 'Professional interior design and renovation',
    tiers: {
      good: {
        title: 'Design Consultation Package',
        price: 2500,
        description: 'Professional design guidance and planning',
        bulletPoints: ['2-room design consultation', 'Color & furniture recommendations', 'Shopping list with sources', 'Basic floor plan layouts']
      },
      better: {
        title: 'Complete Room Makeover',
        price: 8000,
        description: 'Full design service with implementation',
        bulletPoints: ['3-4 room complete design', 'Furniture sourcing & coordination', '3D renderings & mood boards', 'Project management', 'Styling & installation']
      },
      best: {
        title: 'Luxury Home Transformation',
        price: 25000,
        description: 'Whole-home design with premium finishes',
        bulletPoints: ['Entire home design consultation', 'Custom furniture & millwork', 'Premium material selection', 'Contractor coordination', 'Art & accessory curation', 'White-glove installation', '1-year design warranty']
      }
    }
  },
  {
    id: 'catering',
    name: 'Catering Services',
    icon: '🍽️',
    description: 'Professional catering for all occasions',
    tiers: {
      good: {
        title: 'Basic Catering Package',
        price: 850,
        description: 'Simple catering for small events (25 people)',
        bulletPoints: ['Buffet-style service', 'Choice of 2 entrees', 'Basic sides & salad', 'Disposable tableware', 'Basic setup & cleanup']
      },
      better: {
        title: 'Premium Event Catering',
        price: 1800,
        description: 'Full-service catering with enhanced options',
        bulletPoints: ['Plated dinner service', 'Choice of 3 entrees', 'Appetizer station', 'Premium sides & salads', 'Professional tableware', 'Wait staff included', 'Bar service setup']
      },
      best: {
        title: 'Luxury Event Experience',
        price: 3500,
        description: 'Complete event catering with premium service',
        bulletPoints: ['Multi-course plated service', 'Chef-curated seasonal menu', 'Premium appetizer stations', 'Full bar service with bartender', 'Upgraded linens & centerpieces', 'Event coordination', 'Post-event cleanup', 'Custom menu design']
      }
    }
  },
  {
    id: 'auto-detailing',
    name: 'Auto Detailing',
    icon: '🚗',
    description: 'Professional automotive detailing and protection',
    tiers: {
      good: {
        title: 'Basic Detail Package',
        price: 150,
        description: 'Essential car cleaning and maintenance',
        bulletPoints: ['Exterior wash & wax', 'Interior vacuum & wipe down', 'Window cleaning', 'Tire shine application']
      },
      better: {
        title: 'Premium Detail Service',
        price: 300,
        description: 'Comprehensive detailing with protection',
        bulletPoints: ['Paint decontamination & polish', 'Interior deep cleaning & conditioning', 'Engine bay cleaning', 'Ceramic spray coating', 'All surfaces protected', '30-day shine guarantee']
      },
      best: {
        title: 'Showroom Perfection Package',
        price: 600,
        description: 'Ultimate detailing with long-term protection',
        bulletPoints: ['Paint correction & ceramic coating', 'Interior leather restoration', 'Headlight restoration', 'Undercarriage cleaning', 'Paint protection film consultation', '6-month coating warranty', 'Monthly maintenance wash included']
      }
    }
  },
  {
    id: 'videography',
    name: 'Videography',
    icon: '🎬',
    description: 'Professional video production and editing',
    tiers: {
      good: {
        title: 'Basic Video Package',
        price: 1500,
        description: 'Essential video coverage and editing',
        bulletPoints: ['4 hours of filming', 'Basic editing & color correction', 'Background music', 'Digital delivery (MP4)', 'One revision round']
      },
      better: {
        title: 'Professional Video Production',
        price: 3000,
        description: 'Complete video production with enhanced features',
        bulletPoints: ['8 hours of filming', 'Professional editing & color grading', 'Custom graphics & titles', 'Drone footage included', 'Premium music licensing', 'Multiple format delivery', 'Three revision rounds', 'Social media versions']
      },
      best: {
        title: 'Cinematic Video Experience',
        price: 5000,
        description: 'Premium video production with full post-production',
        bulletPoints: ['12+ hours of filming', 'Cinematic editing & advanced color grading', 'Custom motion graphics & animations', 'Multi-camera setup', 'Professional audio recording', 'Same-day highlight reel', 'Full raw footage delivery', 'Unlimited revisions', 'Custom branded delivery portal', '1-year cloud storage']
      }
    }
  },
  {
    id: 'tree-service',
    name: 'Tree Services',
    icon: '🌳',
    description: 'Professional tree care and removal',
    tiers: {
      good: {
        title: 'Basic Tree Service',
        price: 450,
        description: 'Essential tree maintenance and care',
        bulletPoints: ['Tree pruning/trimming', 'Debris removal', 'Basic safety inspection', 'Cleanup included']
      },
      better: {
        title: 'Complete Tree Care',
        price: 1200,
        description: 'Comprehensive tree health and maintenance',
        bulletPoints: ['Professional tree assessment', 'Structural pruning', 'Disease & pest treatment', 'Stump grinding', 'Soil analysis', '6-month health guarantee']
      },
      best: {
        title: 'Premium Arborist Service',
        price: 2800,
        description: 'Expert tree care with ongoing maintenance',
        bulletPoints: ['Certified arborist consultation', 'Complete tree inventory', 'Advanced treatment programs', 'Emergency tree service priority', 'Replacement tree planting', 'Annual care program', '2-year tree health warranty']
      }
    }
  }
];

// Helper function to generate demo quote URL
export const getDemoQuoteUrl = (industryId) => {
  return `/demo-quote/${industryId}`;
};

// Helper function to get industry by ID
export const getIndustryById = (id) => {
  return industryQuotes.find(industry => industry.id === id);
};
